module.exports = __webpack_public_path__ + "static/img/ba2.db189eba.png";